import classNames from 'classnames';
import { useErrorProps } from "../../helper/hooks/useErrorProps.js";
import { Tile } from "../tile/Tile.js";
import styles from "./TileGroup.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TileGroup({
  tiles,
  onChange,
  value,
  alignment,
  variant,
  condensed,
  alwaysShowOutline,
  className,
  error
}) {
  const classes = classNames(styles.tileGroup, styles.tiles, condensed && styles.condensed, className);
  const {
    errorMessage,
    errorInputProps
  } = useErrorProps({
    error
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      role: "radiogroup",
      className: classes,
      ...errorInputProps,
      children: tiles.map((tile, index) => /*#__PURE__*/_jsx(Tile, {
        checked: tile.value === value,
        onChange: onChange,
        alignment: alignment,
        variant: variant,
        alwaysShowOutline: alwaysShowOutline,
        error: error,
        ...tile
      }, index))
    }), errorMessage]
  });
}